const careersSlider = () => {
  if (exists('.careers_carousel')) {
    $('.careers_carousel .content_container').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: false,
      cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
      dots: true,
      draggable: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      speed: 500,
      swipe: true,
      touchMove: true,
      variableWidth: false,
    });
  }
};

const copyToClipboard = () => {
  if (exists(`.copy-link`)) {
    var clipboard = new ClipboardJS('.copy-link');

    const createTooltip = el => {
      const div = document.createElement('div');
      div.classList.add('tooltip--copy');
      div.innerHTML = 'Copied!';
      el.appendChild(div);

      setTimeout(() => {
        el.removeChild(div);
      }, 3000);
    };

    clipboard.on('success', function(e) {
      createTooltip(e.trigger);
    });
  }
};

const scrollToElement = () => {
  const manualOffset = 33;

  function getTop() {
    return Array.from(getHeaders()).reduce(
      (acc, node) => acc + node.clientHeight,
      0,
    );
  }

  function getHeaders() {
    return jQuery('body>nav')
      .filter(':visible')
      .toArray();
  }

  new Component({
    component: document.querySelectorAll('a[href^="#"]'),
    callback: el => {
      el.addEventListener('click', function(e) {
        const id = el.href.split('#')[1];
        const target = document.getElementById(id);
        if (!target) {
          return;
        }

        const targetPosition = target.offsetTop;
        const navHeight = getTop();

        e.preventDefault();

        if (targetPosition < navHeight * 3) {
          window.scrollTo({
            top: targetPosition - manualOffset,
            behavior: 'smooth',
          });
        } else {
          window.scrollTo({
            top: targetPosition - navHeight - manualOffset,
            behavior: 'smooth',
          });
        }
      });
    },
  });
};

window.addEventListener('load', () => {
  careersSlider();
  copyToClipboard();
  scrollToElement();
});
